import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";
import discount2 from "../image/discount2.png";
// import JanhitChemist from "../image/Janhit Chemist.png";                
import finallogo from "../image/finallogo.png"

import { forgotPassword } from "../features/auth/authSlice"; // Ensure this path is correct
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authState = useSelector((state) => state.auth);
  const status = authState?.forgotPassword?.status || "idle";
  const error = authState?.forgotPassword?.error;

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await dispatch(forgotPassword(values.email)).unwrap();
        toast.success("Password reset email sent successfully!");
        navigate("/otppage");
      } catch (error) {
        toast.error("Invalid email address");
        console.error("Error during password reset:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="brand-logo">
      <div className="container">
        <div className="row">
          {/* Brand logo */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="brand-logo-main text-center">
              <img src={finallogo} className="logo-login mb-4" alt="Brand Logo" />
            </div>
          </div>

          {/* Welcome message */}
          <div className="col-lg-7 col-md-7 col-sm-7 col-12 text-center weltezt">
            <img src={discount2} alt="Discount"  width="400" height="400"/>
            <h5 className="mt-4">Welcome to Janhit Chemist</h5>
            <p>
              Sign up with us and get exclusive discounts and saving on medicines. Get express
              delivery in 2 hours.
            </p>
          </div>

          {/* Forgot password form */}
          <div className="col-lg-5 col-md-5 col-sm-5 col-12">
            <div className="from-section card login-card">
              <h5 className="text-login main">Forgot Password</h5>
              <form onSubmit={formik.handleSubmit}>
                <input
                  type="email"
                  id="req5"
                  className={`form-control ${
                    formik.touched.email && formik.errors.email ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Your Email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="invalid-feedback">{formik.errors.email}</div>
                ) : null}

                <br />
                <div className="link-buttn">
                  <button type="submit" className="btn btn-primary w-100" disabled={formik.isSubmitting}>
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
